module.exports = __webpack_public_path__ + "static/Forager-update-e2cf4dc2d069f5c0a6c089510c68edf7.webp";